import {
  ASSET_STATUS_LABELS,
  isExceptionStatus,
  type AssetStatus,
  type PublicAsset,
} from '@inventohub/shared';

export function ExceptionBanner({
  status,
  label,
  testId = 'exception-banner',
}: {
  status: AssetStatus | null | undefined;
  label?: string;
  testId?: string;
}): React.JSX.Element | null {
  if (!status || !isExceptionStatus(status)) return null;
  return (
    <p className="status status--warn" data-testid={testId} role="status">
      {label ?? 'This asset'} is {ASSET_STATUS_LABELS[status]}. It stays on its current loadout
      until an admin or equipment admin clears the status.
    </p>
  );
}

export function ToteExceptionBanner({
  assets,
  toteNumber,
}: {
  assets: PublicAsset[];
  toteNumber: string;
}): React.JSX.Element | null {
  const exceptions = assets.filter((asset) => isExceptionStatus(asset.status));
  if (exceptions.length === 0) return null;
  return (
    <p className="status status--warn" data-testid="tote-exception-banner" role="status">
      Tote {toteNumber} contains missing or broken assets:{' '}
      {exceptions
        .map((asset) => `${asset.serial} (${ASSET_STATUS_LABELS[asset.status]})`)
        .join(', ')}
      . Official membership is unchanged.
    </p>
  );
}
